const AddOwner = () => {
  return (
    <div>
      <h1>Add Owner</h1>
    </div>
  );
};

export default AddOwner;
